import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import reducer, { initialState } from './context/reducer';

import { StateProvider } from './context/StateProvider';

ReactDOM.render(
  <Router >
  <StateProvider initialState={initialState} reducer={reducer}>
    <App />
  </StateProvider>
  </Router>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

